export const widgetStyles = {
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '12px',
  backgroundColor: 'background.paper',
  boxShadow: ({ palette }) => palette.shadow.s,
  marginBottom: '16px',
  overflow: 'hidden',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '14px 18px 12px',
};

export const titleGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  minWidth: 0,
};

export const badgeStyles = {
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'primary.contrastText',
  backgroundColor: 'primary.main',
};

export const titleTextGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

export const progressGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  flexShrink: 0,
};

export const progressTextGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '4px',
};

export const terminalButtonStyles = {
  whiteSpace: 'nowrap',
};

export const getChevronButtonStyles = isExpanded => ({
  width: '30px',
  height: '30px',
  minWidth: '30px',
  padding: 0,
  borderColor: 'divider',
  color: 'text.secondary',
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 150ms ease',
});

export const calloutSectionStyles = {
  padding: '0 16px 16px',
};

export const calloutChipsRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  marginTop: '10px',
};

export const detailSectionStyles = {
  borderTop: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.default',
  padding: '4px 18px',
};
